import unescapedText from 'I18n/utils/unescapedText';
import { PathKey } from '../../constants/paths';

export type BreadcrumbConfig = {
  text: string;
  testId: string;
};

// Only static path keys are listed here. Dynamic paths (FEATURED_COLLECTION,
// LISTING_DETAILS) are intentionally absent — their label and test ID are
// derived from the runtime `title` prop instead of a static translation.
let BREADCRUMB_CONFIG: Partial<Record<PathKey, BreadcrumbConfig>>;

export function getBreadcrumbConfig() {
  if (!BREADCRUMB_CONFIG) {
    BREADCRUMB_CONFIG = {
      HOME: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.marketplace'),
        testId: 'storefront-breadcrumb-marketplace',
      },
      APPS: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.apps'),
        testId: 'storefront-breadcrumb-apps',
      },
      AGENTS: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.agents'),
        testId: 'storefront-breadcrumb-breeze-agents',
      },
      WORKFLOW_TEMPLATES: {
        text: unescapedText('marketplaceStorefront.storefrontNav.workflows'),
        testId: 'storefront-breadcrumb-workflows',
      },
      SOLUTIONS_PARTNERS: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.solutions'),
        testId: 'storefront-breadcrumb-solutions',
      },
      SEARCH_RESULTS: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.explore'),
        testId: 'storefront-breadcrumb-all-products',
      },
      FEATURED: {
        text: unescapedText('marketplaceStorefront.breadcrumbs.featured'),
        testId: 'storefront-breadcrumb-collections',
      },
    };
  }
  return BREADCRUMB_CONFIG;
}
